const DigitalMarketingOptions = {
  styling: {
    BackgroundColor: '#F0B22B',
    ButtonBackground: '#F0B22B',
    ButtonColor: '#FFFFFF',
    ButtonBorderColor: '#FFFFFF'
  },
  banner: {
    Image: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/landing-logo.webp',
    Title: 'Your Marketing People.',
    Content: 'We Help You Market Your Business Online (so you can focus on doing what you love)',
    Video: null,
    ShowVideo: false
  },
  header: {
    LogoImage: "https://net-engine.s3.us-east-2.amazonaws.com/assets/landing-logo1.webp",
    BackgroundColor: '#FFFFFF',
    TextColor: '#000000',
    TextAlign: 'center',
    PaddingTop: 20,
    PaddingBottom: 20
  },
  menu: {
    LogoImage: "https://net-engine.s3.us-east-2.amazonaws.com/assets/landing-logo1.webp",
    BackgroundColor: '#FFFFFF',
    TextColor: '#000000',
    TextAlign: 'center',
    PaddingTop: 20,
    PaddingBottom: 20,
    ShowHome: true
  },
  services: {
    Title: 'What Our Team Can Do For You.',
    Content: 'Ready to grow your Small Business using Smart little Internet based Ads? Get your "Grow your Business with Ads" Guide from Content DFY!',
    Color: '#FFFFFF',
    FontSize: 24,
    Align: 'center',
    FontWeight: 'initial',
    FontStyle: 'initial',
    Padding: 50,
    BackgroundColor: '#FFFFFF',
    TextColor: '#000000',
    Items: [
      {
        Title: 'FACEBOOK CONTENT/SCHEDULING',
        Content: 'Power your Facebook page with custom marketing content that is branded with your logo. 2 posts a day every single day. We do the heavy lifting so you can focus more on doing what you love.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/facebook.webp',
        IsActive: true
      },
      {
        Title: 'WEBSITES THAT CONVERT',
        Content: 'You need more than a website. You need a website that is designed to convert visitors into active customers. Let our lead marketing team build you a site that brings in new business.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/website-convert.webp',
        IsActive: true
      },
      {
        Title: 'MONTHLY NEWSLETTERS',
        Content: 'You\'ve been building an email list of customers and potential customers. Now let us send out topical content that converts that list into even more business.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/newsletter.webp',
        IsActive: true
      },
      {
        Title: 'GOOGLE ADVERTISING',
        Content: 'Want to skip to the head of the line on Google and be in Prime Territory when someone Searches for your Industry? We can help you do that now.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/google-advertising.webp',
        IsActive: false
      },
      {
        Title: 'SEARCH ENGINE OPTIMIZATION',
        Content: 'Want to show up in a better spot when someone searches for your industry on Google? We can help you do that for multiple keywords.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/seo.webp',
        IsActive: false
      },
      {
        Title: 'MESSENGER BOTS',
        Content: 'Wouldn’t it be nice if you had a robot that was always working to promote your business to potential new customers on Facebook. We can build one for you.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/message-bot.webp',
        IsActive: false
      },
      {
        Title: 'LEAD GENERATION',
        Content: 'Want to leverage the power of Facebook ads to get new customers through the door? We’re experts at that. Contact us for details on how we can help you.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/lead-generation.webp',
        IsActive: false
      },
      {
        Title: 'BOOK GHOSTWRITING',
        Content: 'Want to leverage the power of a book to get new customers through the door? Contact us to learn how our expert writing team can help you write your book.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/digital-asset.webp',
        IsActive: false
      },
      {
        Title: 'REPUTATION MANAGEMENT',
        Content: 'Make sure that people searching for your business are finding the right things. We help make sure that your online reviews cast your business in the best light.',
        Icon: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/reputataion-management.webp',
        IsActive: false
      }
    ],
    PaddingTop: 40,
    PaddingBottom: 40
  },
  articles: {
    Title: 'Featured Articles',
    BackgroundColor: '#FFFFFF',
    TextColor: '#000000',
    BoxBackgroundColor: '#FFFFFF',
    BoxTextColor: '#000000',
    PaddingTop: 40,
    PaddingBottom: 40
  },
  about: {
    Title: 'About',
    Content: 'Ben Adkins is a Licensed Chiropractic Physician and the Founder of Content DFY. Ben grew his Chiropractic Practice using Online Marketing and then went on to help other local businesses do the same with his Agency. Ben started Content DFY to help business owners market their business online, so that they can focus on doing what they love.',
    Image: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/user.webp',
    BackgroundColor: '#FFFFFF',
    TextColor: '#000000',
    PaddingTop: 40,
    PaddingBottom: 40
  },
  contact: {
    Hide: false,
    Title: 'We Love To Hear From You',
    CallUs: '',
    TextColor: '#000000',
    BackgroundImage: 'https://net-engine.s3.us-east-2.amazonaws.com/assets/contact-sec-bg.webp'
  },
  footer: {
    Copyright: '© 2022 Content DFY',
    BackgroundColor: '#252525',
    TextColor: '#FFFFFF',
    TextColor1: '#4B4B5A',
    PaddingTop: 36,
    PaddingBottom: 15
  }
}
export default DigitalMarketingOptions